import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    moreIconCard: {
        color: theme.palette.text.primary,
        fontWeight: 400,
    },
    bottleneckIcon: {
        height: "20px",
    },
    cardContent: {
        cursor: "pointer",
    },
    cardActionsContainer: {
        display: "flex",
        justifyContent: "space-between",
        "&.MuiCardActions-root": {
            padding: "0 8px",
        },
    },
    cardActionsContainerOnlyOne: {
        display: "flex",
        justifyContent: "flex-end",
        "&.MuiCardActions-root": {
            padding: "0 8px",
        },
    },
    cardContainer: {
        "&.MuiPaper-root": {
            width: "100%",
            height: "100%",
            background: theme.palette.secondary.main,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
        },
    },
    cardContainerBottleneck: {
        "&.MuiPaper-root": {
            width: "100%",
            height: "100%",
            background: theme.palette.corporateBO.bottleneckCardBackground,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
        },
    },
    shortName: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "5px",
        },
    },
    name: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 400,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    iconsContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
    },
    clusterIcon: {
        color: theme.palette.info.main,
        position: "absolute",
        top: "15px",
    },
    tooltip: {
        marginBottom: `${theme.spacing(2)} !important`,
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.light,
            border: "1px solid rgba(193, 200, 218, 1)",
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    hmiCodeText: {
        fontWeight: "600 !important",
        color: theme.palette.info.main,
    },
    refreshButton: {
        "&.Mui-disabled:disabled": {
            "& > svg": {
                color: theme.palette.primary.dark,
            },
        },
    },
    refreshIcon: {
        color: theme.palette.info.main,
    },
    loadingContainer: {
        padding: "8px",
    },
    hmiCodeContainer: {
        cursor: "pointer",
        marginTop: theme.spacing(1),
    },
}));
